module.exports = __webpack_public_path__ + "img/logo-modern-restaurant-sidebar.3c37d622.png";